import type { HTMLAttributes, ReactNode } from "react";
import "./Badge.css";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** lime = soft label on white (default), ink = strong count on white,
      onDark = on the dark side panel, accent = solid lime (done / valid on a
      dark panel), warning / neutral / danger = status */
  tone?:
    | "lime"
    | "ink"
    | "onDark"
    | "accent"
    | "warning"
    | "neutral"
    | "danger";
  /** xs = tiny tag next to a name, sm = default, md = card header */
  size?: "xs" | "sm" | "md";
  className?: string;
  children: ReactNode;
}

/** Report status variants share the same palette as other app badges. */
export const getStatusBadgeTone = (variant: string): BadgeProps["tone"] => {
  if (["success", "strong", "approved"].includes(variant)) return "lime";
  if (["warning", "medium", "conditional", "review"].includes(variant))
    return "warning";
  if (["danger", "weak", "rejected"].includes(variant)) return "danger";
  return "neutral";
};

/**
 * Small pill label.
 * Example: <Badge>Default</Badge>
 */
const Badge = ({
  tone = "lime",
  size = "sm",
  className = "",
  children,
  ...rest
}: BadgeProps) => (
  <span
    {...rest}
    className={`ds-badge ds-badge--${tone === "onDark" ? "on-dark" : tone} ds-badge--${size} ${className}`.trim()}
  >
    {children}
  </span>
);

export default Badge;
